export default {
  title: "",
  subtitle: "Mexican Person Registration",
  path: "person_registration_mx",
  paragraph: "In Mexico you will need to register a CURP (18 digits) and, if you have one, an RFC (13 digits). This way, once the payment is received and the documents are identified, we can process it. Below you can see a payload with the initial information required. For other requirements, depending on the payment method, see the table 'Information needed for registration (Person)'",
  request: {
    payload: {
      "person": {
        "document_number": "SOMH031031HSRTRR04",
        "document_type": "curp",
        "social_name": "Horacio Soto Morales",
        "fiscal_country": "Mexico",
        "rfc_pf": "SOMH031031C50"
      }
    },
    responses: {
      "data": {
        "updated_at": "2023-08-07T20:50:54.920150",
        "status": "approved",
        "social_name": "Horacio Soto Morales",
        "required_clearance_level": 1,
        "references": [],
        "phone_number": null,
        "net_monthly_average_income": null,
        "inserted_at": "2023-07-20T13:33:08.286343",
        "id": "9fc9ad01-1b1f-466e-b50d-51cdc46fab8b",
        "fiscal_country": "Mexico",
        "rfc_pf": "SOMH031031C50",
        "email": null,
        "documents": [],
        "document_type": "curp",
        "document_number": "SOMH031031HSRTRR04",
        "clearance_level": 1,
        "birth_date": null,
        "address_street": null,
        "address_state": null,
        "address_postal_code": null,
        "address_number": null,
        "address_country": null,
        "address_complement": null,
        "address_city": null
      }
    }
  },
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        code: {
          "errors": {
            "rfc_pf": [
              "invalid RFC_PF"
            ]
          }
        },
        solution: 'If you are registering a customer with both CURP and RFC_PF, the first 10 digits of these identifiers must match. If they do not, this error will be returned. You can generate a fake CURP and RFC for tests using this link: "https://datafakegenerator.com/genrfc".'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonRegistrationMX.js